export interface Requests {
  project_id: string,
  project_name: string,
  request_id: number,
  requests_date: string,
  employee_phm: number,
  requests_cid: number,
  requests_person: number,
  requests_submit: string,
  purchasing_price: number,
  purchasing_id: string,
  selling_price: number,
  status: string,
  subject: string,
  requests_company: string,
  requests_salutation: string,
  requests_firstname: string,
  requests_lastname: string,
  reqstreet: string,
  reqpostcode: string,
  reqcity: string,
  reqcountry: string,
  for_pdf?: number,
  comment?:string
}

export interface RequestList {
  comment_phm:  string,
  company_name:  string,
  controlling_nr:  string,
  description: string,
  for_pdf: boolean,
  heat_nr:  string,
  material: string,
  name: string,
  number_of_pieces: number,
  part: number,
  position: number,
  /** Originalnotation aus dem Altsystem (z. B. "6.1"); leer bei PPS-Zeilen. */
  position_label?: string,
  project_number: string,
  purchasing_price: number
  remarks:  string,
  reqcid: number,
  reqid: number,
  request_status: null,
  serial_nr:  string,
  side_agreements:  string,
  specification:  string,
  taric: string,
  technical_drawing: string,
  technology: boolean,
  request_position_status:  string,
  weight: number,
}
export class SingleRequest {
  project_id: string = '';
  project_name: string = '';
  request_id: number = 0;
  requests_date: string = '';
  employee_phm: number = 0;
  requests_cid: number = 0;
  requests_person: number = 0;
  requests_submit: string = '';
  purchasing_price: number = 0;
  purchasing_id: string = '';
  selling_price: number = 0;
  status: string = '';
  subject: string = '';
  requests_company: string = '';
  requests_salutation: string = '';
  requests_firstname: string = '';
  requests_lastname: string = '';
  reqstreet: string = '';
  reqpostcode: string = '';
  reqcity: string = '';
  reqcountry: string = '';
  for_pdf?: number = 0;
  comment?:string = '';
}

export interface RequestPDF {
  for_pdf: boolean,
  request_id: number,
  part: number,
  position: number,
  project_id: string
}

export interface Request {
  stepI: StepI;
  stepII: StepII;
  stepIII: StepIII;
}

class StepI {
  project_id: string = '';
  reqcid: number = 0;
  company_name: string = '';
  reqstreet: string = '';
  reqpostcode: string = '';
  reqcity: string = '';
  reqcountry: string = '';
  reqsubject: string = '';
  purchasing_id: string = '';
  reqdate: string = '';
  reqsubmit: string = '';
  reqstatus: string = '';
}

class StepII {
  employee_phm: number = 0;
}

class StepIII {
  employee_req: number = 0;
}
